export default __webpack_public_path__ + "static/media/GrandEst.718f0174.jpg";